
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
// This component wraps each child component in a div that handles displaying
// the correct tab item

export default {
  name: 'NsTabsItems',
  props: {
    selected: {
      type: [String, Number],
      default: null,
    },
  },
  methods: {
    isSelected(index) {
      const vNode = this.$slots.default.filter((slot) => slot.tag)[index];
      const value =
        vNode.data && vNode.data.attrs && vNode.data.attrs['data-value'];

      if (value) {
        return String(this.selected) === String(value);
      } else {
        return this.selected === index;
      }
    },
  },
  render(createElement) {
    if (!this.$slots.default) {
      return null;
    }

    return createElement(
      'div',
      { class: this.$style.container },
      this.$slots.default
        .filter((slot) => slot.tag)
        .map((child, index) =>
          createElement(
            'div',
            {
              class: [
                this.$style.item,
                {
                  [this.$style.selected]: this.isSelected(index),
                },
              ],
            },
            [child]
          )
        )
    );
  },
};
